import SortingResponse from './SortingResponse';
import './SelectedResponseCards.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  pageIndex: 0,
  promptKey: null,
  responseCards: [],
  selectedResponseCards: [],
};

export default function SelectedResponseCards(p) {
  const { pageIndex, promptKey, responseCards, selectedResponseCards } = { ...defaultProps, ...filterUndefined(p) };
  const matchedResponseCards = [];
  selectedResponseCards.forEach((cardIndex) => {
    if (responseCards[cardIndex].key === promptKey) {
      matchedResponseCards.push(responseCards[cardIndex]);
    }
  });

  return (
    <div className='selected-response-cards-component'>
      {matchedResponseCards.map((card, cardIndex) => (
        <div
          key={`selected-response-display-${pageIndex}-${cardIndex}`}
          className={`${matchedResponseCards.length < 7 ? 'selected-response-display' : 'selected-response-display-small'} `}
        >
          <SortingResponse responseCard={card} disablePlayMedia />
        </div>
      ))}
    </div>
  );
}
